import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Profile from "../../components/User/Profile";

export default withRouter(connect()(Profile));
